import { Component, OnInit } from '@angular/core';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { PARAMS } from '../../../contants/PARAMS';
import { TripColumns } from '../../../contants/columns/columns.trip';
import { PageOption } from '../../../models/common/pageOption';
import { TableColumn } from '../../../models/tables/TableColumn';
import { ITripSearchResult } from '../../../models/trips/trip';
import { TripFilter } from '../../../models/trips/tripFilter';
import { AlertService } from '../../../services/alert.service';
import { ParameterService } from '../../../services/parameter.service';
import { TripService } from '../../../services/trip.service';
import { PaginatedList } from './../../../models/common/paginatedList';

@Component({
	selector: 'app-trip-list',
	templateUrl: './trip-list.component.html',
	styleUrls: ['./trip-list.component.css']
})
export class TripListComponent implements OnInit {
	pageOption: PageOption<TripFilter> = new PageOption();
	formPath: string = APP_ROUTES.tripForm;

	public paginatedTrip: PaginatedList<ITripSearchResult> | undefined = undefined;
	public tableColumns: TableColumn[] = TripColumns;

	constructor(
		private _tripService: TripService,
		private _parameterService: ParameterService,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		this.pageOption.searchFilter = new TripFilter();
		this.pageOption.searchFilter.isPaid = false;

		this._parameterService.getCachedParameterObject<TableColumn[]>(PARAMS.TRIP_TABLE_DEFAULT_COLUMNS, 3600).subscribe(
			result => {
				if (result != undefined && result.length != undefined) {
					this.tableColumns = result.length == 0 ? this.tableColumns : result;
				}
				else {
					console.log('Invalid response from server, will use default column settings instead.')
				}
			});

		this._parameterService.getCachedParameter<number>(PARAMS.TRIP_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
			value => {
				value = Number(value);
				this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
				this.pageOption.pageNumber = 1;

				this.fetchData();
			}
		);
	}

	fetchData(){
		this._tripService.searchV2(this.pageOption).subscribe(
			result => {
				this.paginatedTrip = result;
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	search(filter: TripFilter) {
		this.paginatedTrip = undefined;
		this.pageOption.searchFilter = filter;
		this.fetchData();
	}

	onDelete(index: number){
		this._tripService.deleteTrip(this.paginatedTrip.data[index].id).subscribe(
			result => {
				if (result.object != null) {				
					this.fetchData(); //refetch updated records
					this._alertService.showSuccess('Trip is deleted');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/components/trips/trip-list/trip-list.component.ts